import React from "react";
import {useDispatch} from "react-redux";
import {setSendData} from "../../../Store/Slice/scheduleSlice";

const FieldDropDown = ({
     data,
     field_name,
     setPrimaryContact,
     setCurrentFieldType,
     setDropdownData,
     phoneValidation,
   }) => {
  return (
    <>
      {data?.length > 0 && (
        <div className="verify__dropdown">
          {data?.map((elem, index) => (
            <div
              className="verify__dropdown-elem"
              key={index}
              onClick={() => {
                setPrimaryContact.set({
                  firstname: elem?.firstname,
                  lastname: elem?.lastname,
                  phone: elem?.phone,
                  email: elem?.email,
                });
                phoneValidation(elem?.phone);
                setCurrentFieldType(null);
                setDropdownData([]);
              }}
            >
              <p className="verify__dropdown-title">{elem?.firstname}</p>
              <p className="verify__dropdown-subtitle">
                <span>{elem?.phone}</span>
                <span>{elem?.email}</span>
              </p>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default FieldDropDown;
